import { httpDelete, httpGet, httpPost } from "@/api/connection";
import { CreateApiKeyFn, GetApiKeysFn } from "./api-keys.types";

const getApiKeys: GetApiKeysFn = async (query) => {
  const { uuid, ...rest } = query ?? {};

  if (uuid) {
    return httpGet(`/api-keys/${uuid}`, rest);
  }

  return httpGet("/api-keys", rest);
};

const createApiKey: CreateApiKeyFn = async () => {
  return await httpPost(`/api-keys`);
};

const deleteWebhook = async (uuid: string) => {
  return await httpDelete(`/api-keys/${uuid}`);
};

export const ApiKeysAPI = {
  get: getApiKeys,
  create: createApiKey,
  delete: deleteWebhook,
};
